/* eslint-disable @typescript-eslint/no-explicit-any */
export default function checkFormUpdate(dataAfterChange: any, dataBeforeChange: any) {
  const keys = Object.keys(dataAfterChange);
  const result: any = {};

  keys.map((x) => {
    if (typeof dataAfterChange[x] === 'object') {
      if (JSON.stringify(dataAfterChange[x]) !== JSON.stringify(dataBeforeChange[x])) {
        result[x] = dataAfterChange[x];
      }
    } else {
      if (dataAfterChange[x] !== dataBeforeChange[x]) {
        result[x] = dataAfterChange[x];
      }
    }
  });

  return result;
}
